import { useQuery } from '@apollo/client';
import get from 'lodash/get';
import set from 'lodash/set';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const usePaginator = ({
  query,
  variables,
  itemsKey,
  limit: amountOfItemsPerPage,
}) => {
  const router = useRouter();
  const [firstNewItem, setFirstNewItem] = useState();
  const [limit, setLimit] = useState(amountOfItemsPerPage);

  useEffect(() => {
    setLimit(
      router.query.limit
        ? parseInt(router.query.limit, 10)
        : amountOfItemsPerPage
    );
  }, [amountOfItemsPerPage, router]);

  const { data, networkStatus, fetchMore } = useQuery(query, {
    fetchPolicy: 'network-only',
    variables: {
      ...variables,
      paginator: {
        ...variables.paginator,
        limit,
      },
    },
  });

  const items = get(data, `${itemsKey}.edges`, []);
  const endCursor = get(data, `${itemsKey}.pageInfo.endCursor`);
  const hasNextPage = get(data, `${itemsKey}.pageInfo.hasNextPage`);
  const loading = networkStatus <= 3;
  const firstLoad = networkStatus === 1;

  const loadMore = () => {
    fetchMore({
      variables: {
        paginator: {
          cursor: endCursor,
          limit,
        },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newData = {
          ...fetchMoreResult,
        };

        setFirstNewItem(get(newData, `${itemsKey}.edges[0]`, null));

        const previousItems = get(previousResult, `${itemsKey}.edges`);
        const newItems = get(fetchMoreResult, `${itemsKey}.edges`);

        set(newData, `${itemsKey}.edges`, [...previousItems, ...newItems]);

        return newData;
      },
    });
  };

  return {
    endCursor,
    loading,
    firstLoad,
    hasNextPage,
    items,
    loadMore,
    firstNewItem,
  };
};

export default usePaginator;
